import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/** Preserve filters when redirecting legacy conflicts URL → enrollment holds. */
export default function EnrollmentConflictsLegacyRedirect() {
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  return (
    <Navigate
      to={qs ? `/corporations/enrollment-holds?${qs}` : '/corporations/enrollment-holds'}
      replace
    />
  );
}
